export enum NotificationType {
  SHOW_LESS = 'BROWSE_SHOW_LESS',
  REMOVE_DYW = 'REMOVE_DYW',
}

export enum ModalType {
  REMOVE_CONFIRM_DYW = 'REMOVE_CONFIRM_DYW',
}
